import React, { useState } from "react";
import { useMemo, useEffect } from "react";
import { useTable, usePagination } from "react-table";
import { BsCheckLg, BsX, BsPencil, BsTrash } from "react-icons/bs";
import deleteIcon from "../../../assets/svgIcons/delete-icon.svg";
import editIcon from "../../../assets/svgIcons/edit.svg";
import editlight from "../../../assets/svgIcons/editLight-icon.svg";

import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { SagaActions } from "../../../redux/actionTypes";
import { cepAdminType } from "../../../types/cepAdminTypes";
import styled from "styled-components";
import {
  deleteCEPuserReq,
  updateCEPuserReq,
} from "../../../api/cep/cepAdminRequest";

const EditableTable = ({
  columns,
  data,
  setData,
  handleButtonClick,
  updateCEPFun,
}: any) => {
  const totalRecruiterLists = data.length;
  const {
    getTableProps,
    headerGroups,
    getTableBodyProps,
    rows,
    page,
    prepareRow,
    state: { pageIndex = 0, pageSize },
    gotoPage,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    pageCount,
    pageOptions,
    setPageSize,
  }: any = useTable<any>({ columns, data }, usePagination);

  const endIndex = Math.min((pageIndex + 1) * pageSize, totalRecruiterLists);

  const handleInputChange = (event: any, row: any, columnId: any) => {
    const newData = data.map((rowData: any) => {
      if (rowData.userID === row.original.userID) {
        return {
          ...rowData,
          [columnId]: event.target.value,
        };
      }
      return rowData;
    });
    setData(newData);
  };

  return (
    <div className="">
      <div
        className={`d-flex align-items-center my-1 justify-content-between px-3 `}
      >
        <div className={``}>
          {/* <p className="my-1 lg-text">
            <strong>Edit a CEP</strong>
          </p> */}
          <p className={`my-1 md-text`}>Edit a CEP</p>
        </div>
        <label className={`sm-text primary-color`}>
          {/* {pageIndex + 1} of {pageOptions.length} is added */}
          {/* {pageIndex + 1} of 10 is added */}
          {endIndex} of {totalRecruiterLists} CEPs displayed
        </label>
      </div>
      <table {...getTableProps()}>
        <thead>
          {headerGroups?.map((headerGroup: any) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup?.headers.map((column: any) => (
                <th className={`sm-text`} {...column?.getHeaderProps()}>
                  {column?.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page?.map((row: any) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell: any, idx: any) => {
                  return (
                    <td
                      key={idx}
                      {...cell.getCellProps}
                      className={`sm-text text-secondary`}
                    >
                      {cell.column.editEnable ? (
                        row.original.isEditing ? (
                          <div className={`d-flex align-items-center`}>
                            <input
                              className="sm-text table_input rounded p-2"
                              type={
                                cell.column.id === "mobileNumber"
                                  ? "tel"
                                  : "text"
                              }
                              maxLength={
                                cell.column.id === "mobileNumber" ? 10 : 999
                              }
                              defaultValue={cell.value}
                              onChange={(e) =>
                                handleInputChange(e, row, cell.column.id)
                              }
                            />
                            {cell.column.id === "mobileNumber" ? (
                              <>
                                <div
                                  className="py-1"
                                  onClick={() => {
                                    updateCEPFun(row.original);
                                  }}
                                >
                                  <BsCheckLg
                                    className="mx-2"
                                    color={"#3A93F4"}
                                    size={20}
                                  />
                                </div>
                                <div
                                  className="py-1"
                                  onClick={() => {
                                    handleButtonClick("cancel", row.original);
                                  }}
                                >
                                  <BsX
                                    className="mx-2"
                                    color="#D92D20"
                                    size={20}
                                  />
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          cell.render("Cell")
                        )
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="align-items-center mt-3">
        <button
          className="btn btn-outline-dark ms-2"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          {"<"}
        </button>{" "}
        <button
          className="btn btn-outline-dark ms-2"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          {">"}
        </button>{" "}
        <span className="ms-2">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        {/* <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[5, 10, 15, 20, 25].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
      </div>
    </div>
  );
};

// ===========================================================
function CEPTable({ dataIs, dataLength, onDeleteRow }: any) {
  const Dispatch = useDispatch();
  const [data, setdata] = useState<any[]>([]);

  const columnsData = [
    {
      Header: "Name",
      accessor: "nameIs",
      editEnable: true,
      Cell: ({ cell }: any) => {
        return <p className="sm-text text-dark">{cell?.value}</p>;
      },
    },
    {
      Header: "Email",
      accessor: "email",
      editEnable: true,
      Cell: ({ cell }: any) => {
        return (
          <p className="sm-text text-secondary">{cell?.row?.original?.email}</p>
        );
      },
    },
    { Header: "Mobile Number", accessor: "mobileNumber", editEnable: true },
    {
      Header: "Action",
      accessor: "",
      Cell: ({ row, column, cell }: any) => {
        const _userId = cell?.row?.original?.userID;
        const value = cell?.value;

        return (
          <div className={`d-flex align-items-center`}>
            <div
              className={`small_icon_box d-flex me-1`}
              onClick={() =>
                row.original.isEditing
                  ? {}
                  : handleButtonClick("edit", row.original)
              }
            >
              <img
                src={!row.original.isEditing ? editIcon : editlight}
                className="primary-color"
              />
            </div>
            <div
              className={`small_icon_box d-flex ms-1`}
              onClick={() => onDeleteCEP(_userId)}
            >
              <img src={deleteIcon} />
            </div>
          </div>
        );
      },
    },
  ];

  const updateCEPFun = async (recrData: any) => {
    try {
      const userName = recrData.nameIs;
      const firstSpaceIndex = userName?.indexOf(" ") ?? -1;
      const [firstName, lastName] =
        firstSpaceIndex !== -1
          ? [
              userName.slice(0, firstSpaceIndex),
              userName.slice(firstSpaceIndex + 1),
            ]
          : [userName, ""];
      const _data = {
        firstName: firstName || "",
        lastName: lastName || "",
        email: recrData?.email || "",
        mobileNumber: recrData?.mobileNumber || "",
      };
      const res = await updateCEPuserReq(
        { userID: recrData?.userID || "" },
        _data
      );

      toast.success(res?.message);
      handleButtonClick("save", recrData);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "recruiterTable",
          methodName: "updateCEPFun",
          type: "info",
        },
      });
    } catch (error: any) {
      console.log(error, "error in onDeleteCEP");
      handleButtonClick("cancel", recrData);
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "recruiterTable",
          methodName: "updateCEPFun",
          type: "error",
        },
      });
    }
  };

  const onDeleteCEP = async (id: any) => {
    try {
      const res = await deleteCEPuserReq({ userID: id });
      toast.success(res?.message);
      onDeleteRow({ id });
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "recruiterTable",
          methodName: "onDeleteCEP",
          type: "info",
        },
      });
    } catch (error: any) {
      console.log(error, "error in onDeleteCEP");
      if (error?.errorCode + "" === "403") {
        Swal.fire({
          icon: "warning",
          text: error?.errorMsg,
        });
        return;
      }
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "recruiterTable",
          methodName: "onDeleteCEP",
          type: "error",
        },
      });
    }
  };

  const handleButtonClick = (action: any, row: any) => {
    const newData = data.map((rowData: any) => {
      if (rowData.userID === row.userID) {
        if (action === "edit") {
          return { ...rowData, isEditing: true, prevData: { ...rowData } };
        } else if (action === "cancel") {
          return { ...rowData, isEditing: false, ...rowData.prevData };
        } else if (action === "save") {
          const { prevData, ...updatedRowData } = rowData;
          return {
            ...updatedRowData,
            isEditing: false,
          };
        }
      }
      return rowData;
    });
    setdata(newData);
  };

  useEffect(() => {
    if (!dataIs || dataIs?.length < 1) return;
    let formatedData = [];
    for (let i = 0; i < dataIs.length; i++) {
      const e: cepAdminType = dataIs[i];
      const _data = {
        userID: e?.user?.userID || "",
        nameIs: `${e?.employee?.firstName || ""} ${
          e?.employee?.lastName || ""
        }`,
        firstName: e?.employee?.firstName || "",
        lastName: e?.employee?.lastName || "",
        email: e?.user?.email || "",
        mobileNumber: e?.user?.mobileNumber || "",
      };
      formatedData.push(_data);
    }
    setdata(formatedData);
  }, [dataIs]);

  return (
    <MyTable className={``}>
      <EditableTable
        columns={columnsData}
        data={data}
        setData={setdata}
        handleButtonClick={handleButtonClick}
        updateCEPFun={updateCEPFun}
      />
    </MyTable>
  );
}

export default CEPTable;

const MyTable = styled.div`
  table {
    width: 100%;
  }
  select {
    border: none;
    color: #9a9a9a;
  }

  thead th {
    font-size: small;
    color: #9a9a9a;
    font-weight: 400;
    text-transform: capitalize;
    padding: 10px 5px;
  }
  td {
    font-size: 14px;
    padding: 10px 5px;
    // color: #9a9a9a;
    font-weight: 400;
  }
  tr {
    border-bottom: 1px solid rgb(227, 227, 227);
  }
  td:nth-of-type(1),
  th:nth-of-type(1) {
    padding-left: 15px;
  }
  td:nth-of-type(2) {
    color: rgb(0, 0, 0) !important;
    font-size: 14px;
    font-weight: 400;
  }
  .table_input {
    border: 1px solid rgb(200, 200, 200);
  }
`;
